// initialConfiguration is for a use case where you only want the configuration at app start
// and don't want it to change during the app lifecycle
export function initialConfiguration(state = null, action) {
  switch (action.type) {
    case 'FETCH_INITIAL_CONFIGURATION_SUCCESS':
      return action.response

    default:
      return state
  }
}

// liveConfiguration is for a use case where
// you want the configuration to be updated during the app lifecycle.
// local code can further configure how to react to changes based on fetchedAt if needed
export function liveConfiguration(state = null, action) {
  switch (action.type) {
    case 'FETCH_CONFIGURATION_SUCCESS':
      return action.response

    default:
      return state
  }
}
